export default {
  data: [],
  error: false,
  loading: false,
  loadingTable: false,
  reload: false,
  total: 0
};



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/initialState/shared/index.js